import { useEffect, useRef } from "react";
import Hls from "hls.js";
import { HLS_CONFIG, PROTOCOL_TYPES } from "../constant/index";

/**
 * Custom hook to manage video player (HLS)
 * @param {Object} item - Camera item
 * @returns {Object} - Video player state and refs
 */
export const useVideoPlayer = (item) => {
    const videoRef = useRef(null);

    // Setup HLS player
    useEffect(() => {
        let hls;
        const url = item.url;

        if (item.protocol === PROTOCOL_TYPES.HLS) {
            if (Hls.isSupported()) {
                hls = new Hls(HLS_CONFIG);

                hls.loadSource(url);
                hls.attachMedia(videoRef.current);

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    console.log("HLS manifest loaded");
                    videoRef?.current?.play();
                });

                hls.on(Hls.Events.ERROR, (event, data) => {
                    console.error("HLS.js error:", data);
                });
            } else if (videoRef.current?.canPlayType("application/vnd.apple.mpegurl")) {
                // Native HLS support (Safari)
                videoRef.current.src = url;
            }
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [item.protocol, item.url]);

    return {
        videoRef
    };
};

